import {
  type SxProps,
  type AvatarProps,
  type Theme,
  Avatar,
} from '@mui/material';

type Props = AvatarProps;

export const Or2Avatar = ({ sx, ...otherProps }: Props) => {
  const sxProps: SxProps<Theme> = {
    backgroundColor: (theme) => theme.background,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: (theme) => theme.avatarBorder,
    ...sx,
  };
  return <Avatar sx={sxProps} {...otherProps} />;
};
